import { ImageClientWithBlur } from '~/components/ImageClientWithBlur';
import { ImageInterface } from '~/payload-types';
import clsx from 'clsx';

type Props = ImageInterface & {};

export const ImageBlock = (props: Props) => {
  if (typeof props.image === 'number') {
    return null;
  }

  let justify = '';

  switch (props.alignment) {
    case 'left':
      justify = 'justify-start';
      break;
    case 'center':
      justify = 'justify-center';
      break;
    case 'right':
      justify = 'justify-end';
      break;
  }

  return (
    <ImageClientWithBlur
      src={props.image.url!}
      alt={props.image.alt ?? ''}
      width={props.image.width!}
      height={props.image.height!}
      className={clsx(justify, 'flex')}
      blurDataURL={props.image.placeholder ?? undefined}
    />
  );
};
